// extracted by mini-css-extract-plugin
export default {"container":"InfoModal_container__IKw76","row":"InfoModal_row__i8MBN","label":"InfoModal_label__ovuG3","value":"InfoModal_value__h8bb4"};